/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';

const ZipCodeMask = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // guide
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
    />
  );
};

ZipCodeMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default ZipCodeMask;
